var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55434 0.603273C10.0083 -0.222617 12.6768 -0.199901 15.1158 0.66764C16.4552 1.15929 17.6824 1.90537 18.727 2.86309C18.3721 3.23537 17.9977 3.5833 17.6357 3.94515C16.9471 4.61898 16.2592 5.29049 15.5719 5.95968C14.8867 5.31718 14.0578 4.8406 13.1513 4.56795C11.9914 4.22461 10.7575 4.20111 9.58484 4.5C8.41221 4.7989 7.34621 5.40866 6.5038 6.26238C5.76847 6.9957 5.2116 7.88237 4.87474 8.8562L1.19606 6.06406C2.5128 3.50426 4.79267 1.54621 7.55434 0.603273Z",
    fill: "#E33629"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.220042 8.83011C0.417622 7.86942 0.745893 6.93909 1.19606 6.06406L4.87474 8.86316C4.39364 10.2525 4.39364 11.7586 4.87474 13.1479C3.6491 14.0758 2.42288 15.0082 1.19606 15.9453C0.0694706 13.7469 -0.274118 11.2421 0.220042 8.83011Z",
    fill: "#F8BD00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2242 8.94319H21.7864C22.1475 10.8863 22.0498 12.8846 21.5007 14.785C20.9954 16.5324 20.0137 18.1118 18.6614 19.3533C17.4742 18.4452 16.2817 17.5441 15.0945 16.636C15.6831 16.2468 16.1854 15.7451 16.5715 15.161C16.9575 14.5768 17.2193 13.9223 17.3411 13.2367H11.2242C11.2224 11.8067 11.2242 10.3749 11.2242 8.94319Z",
    fill: "#587DBD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.19428 15.9453C2.4211 15.0175 3.64733 14.085 4.87297 13.1479C5.34714 14.5122 6.24898 15.6946 7.44964 16.5264C8.19842 17.0454 9.04941 17.4056 9.94824 17.5841C10.8338 17.7455 11.7422 17.7455 12.6278 17.5841C13.5109 17.4377 14.353 17.1118 15.0998 16.6273C16.287 17.5354 17.4795 18.4365 18.6667 19.3446C17.3675 20.5027 15.7838 21.3102 14.0706 21.6879C12.1796 22.1237 10.209 22.1028 8.32806 21.627C6.84044 21.2376 5.4509 20.5512 4.24654 19.6108C2.97192 18.6185 1.93079 17.3682 1.19428 15.9453Z",
    fill: "#319F43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.d5dc4aae672a10b5c60dcc385c9a6942.svg";
export { ForwardRef as ReactComponent };